
import { v4 as uuidv4 } from "uuid";

const dataGuru = [
  {
    id: uuidv4(),
    name: "Drs. H. Kurnain",
    job: "Kepala Sekolah",
    url: "1",
  },
  {
    id: uuidv4(),
    name: "Lina Ruspita, S.Pd.I",
    job: "Wakamad Kurikulum",
    url: "2",
  },
  {
    id: uuidv4(),
    name: "Hj. Khasiyatul Hasni, S.Pd.I",
    job: "Pembina Osim",
    url: "3",
  },
  {
    id: uuidv4(),
    name: "Ani Widayati, S.Th.I",
    job: "Wakamad Humas",
    url: "4",
  },
  {
    id: uuidv4(),
    name: "H. Rushadi, S.Ag",
    job: "Wakamad Sarana Prasarana",
    url: "5",
  },
  {
    id: uuidv4(),
    name: "Widi Arfika, S.Pd.I",
    job: "Wakamad Kesiswaan",
    url: "6",
  },
  {
    id: uuidv4(),
    name: "Nurul Hilal, S.Pd",
    job: "Bendahara",
    url: "7",
  },
  {
    id: uuidv4(),
    name: "Zainal Hakim, S.Pd.I",
    job: "Kepala TU",
    url: "8",
  }

];

export default dataGuru;


